import { render, staticRenderFns } from "./SelectCustomerModal.vue?vue&type=template&id=c47f6da6&"
import script from "./SelectCustomerModal.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomerModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports